export const getTypeName = (relatedType, reference = "") => {
  switch (relatedType) {
    case 0:
      return "Adjustment";
    case 1:
      return "Login Streak";
    case 2:
      return "Refer a Friend";
    case 3:
      return "Clash";
    case 4:
      return "Registration";
    case 5:
      return "Buy Card";
    case 6:
      return "Sold Card";
    case 7:
      return "Buy Pack";
    case 8:
      return "Free Coins";
    case 9:
      return "Buy Coins";
    case 10:
      return "Challenge Reward";
    case 11:
      return "Mini Game Reward";
    case 12:
      return "Entry Fee";
    case 13:
      return "Swap Coins";
    case 14:
      if (reference === "REDEEMCODE") return "Redeem Code";
      return "Prize Reward";
    case 15:
      return "Fast Track Training";
    case 16:
      return "Profile Complete";
    case 17:
      return "All Access Pass";
    case 18:
      return "Division Top Rank";
    case 19:
      return "Game Provider Fee";
    case 20:
      return "Game Provider Prize";
    case 21:
      return "Buy Contract";
    case 22:
      return "Versus H2H";
    case 23:
      return "Versus Season";
    case 24:
      return "Versus Season Prize";
    case 25:
      return "Versus Game Prize";
    case 26:
      return "Versus Daily";
    case 27:
      return "Promotion";
    case 28:
      return "Turbo Track Training";
    case 29:
      return "Club Challenge Entry";
    case 30:
      return "NHL Gamezone Sync";
    case 31:
      return "Club Challenge Reward";
    case 32:
      return "Club Challenge Refund";
    default:
      return "?";
  }
};
